import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { productClick } from 'redux/products/actions';

const ProductLink = (props) => {
  const handleLink = () => {
    // e.preventDefault();
    const { product } = props;
    props.productClick(product);
    // const location = `/product/${product.slug}`;
    // window.location.assign(location);
  };

  const { displayType, children, linkType, product } = props;
  if (linkType === 'window') {
    return (
      <a href={`/product/${product.slug}`} onClick={handleLink}>
        {children}
      </a>
    );
  }
  switch (displayType) {
    case 'Detail':
      return null;
    case 'Personalization Block':
    case 'Collection':
      return (
        <a href={`/product/${product.slug}`} onClick={handleLink}>
          {children}
        </a>
      );
    case 'List':
      return (
        <Link to={`/product/${product.slug}`} onClick={handleLink}>
          {children}
        </Link>
      );
    default:
      return null;
  }
};

export default connect(null, { productClick })(ProductLink);
